import { formatDistanceToNow, format as formatDate } from 'date-fns';
import { HistoryIcon } from 'app/agriculture/icons';
import './Timestamp.scss';
import classNames from 'classnames';
import { getTimestampDateFormat } from 'app/agriculture/components/Timestamp/timestampUtils';

interface TimestampProps {
    timestamp?: Date;
    className?: string;
}

export function Timestamp({ timestamp, className }: TimestampProps) {
    if (!timestamp) return null;

    const dateFormat = getTimestampDateFormat(timestamp);

    return (
        <div className={classNames('Timestamp', className)}>
            <HistoryIcon className="Timestamp__icon" />
            <h5 className="Timestamp__distance">
                {formatDistanceToNow(timestamp, { includeSeconds: true, addSuffix: true })}
            </h5>
            <p className="Timestamp__exact">({formatDate(timestamp, dateFormat)})</p>
        </div>
    );
}
